import { FC } from 'react';
import { Typography, TypographyProps } from '@mui/material';

interface CalloutTitleProps extends TypographyProps {}

const CalloutTitle: FC<CalloutTitleProps> = ({ children, ...props }) => {
    return (
        <Typography variant="h6" fontWeight="bold" {...props}>
            {children}
        </Typography>
    );
};

export type { CalloutTitleProps };
export default CalloutTitle;
